import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, Cell, Pie } from 'recharts';

function ProgressPie({ data, percent }) {
  return (
    <PieChart width={100} height={100}>
      <text x={50} y={50} textAnchor="middle" dominantBaseline="middle">
        {percent}%
      </text>
      <Pie
        data={data}
        dataKey="value"
        innerRadius="80%"
        outerRadius="100%"
        fill="#CCC"
        startAngle={90}
        endAngle={-270}
        paddingAngle={0}
        cornerRadius={5}
      >
        <Cell key="test" fill="#82ca9d" />
      </Pie>
    </PieChart>
  );
}

ProgressPie.propTypes = {
  data: PropTypes.arrayOf(Object),
  percent: PropTypes.number,
};

export default ProgressPie;
